import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=0106030e&scoped=true"
import script from "./TextView.vue?vue&type=script&lang=js"
export * from "./TextView.vue?vue&type=script&lang=js"
import style0 from "./TextView.vue?vue&type=style&index=0&id=0106030e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0106030e",
  null
  
)

export default component.exports